import { CONTACT_INFO, toBanglaDigits } from "constants/contactInfo";

/**
 * Flat translation map.
 * Usage: t("key", language)
 */
const translations = {
  // Navbar / search
  searchPlaceholder: { bn: "পণ্য খুঁজুন", en: "Search products" },
  noProductFound: { bn: "কোনো পণ্য পাওয়া যায়নি", en: "No product found" },

  // Footer
  shopAddress: {
    bn: "বনলতা মার্কেট, দোকান নং=৫ দ্বিতীয় তলা, ঢাকা নিউমার্কেট, ঢাকা ১২০৫",
    en: "Bonolota Market, Shop no-5, 1st Floor, Dhaka New Market, Dhaka 1205",
  },
  helpline: {
    bn: `হেল্পলাইনঃ ${toBanglaDigits(CONTACT_INFO.helpline.display)}`,
    en: `Help Line: ${CONTACT_INFO.helpline.display}`,
  },
  email: { bn: "ইমেইল", en: "Email" },
  aboutUs: { bn: "আমাদের সম্পর্কে", en: "About Us" },
  contactUs: { bn: "যোগাযোগ", en: "Contact Us" },
  returnPolicy: { bn: "রিটার্ন পলিসি", en: "Return Policy" },
  refundPolicy: { bn: "রিফান্ড পলিসি", en: "Refund Policy" },
  cancellationPolicy: { bn: "ক্যান্সেল পলিসি", en: "Cancellation Policy" },
  socialMedia: { bn: "সামাজিক যোগাযোগ মাধ্যম", en: "Social Media" },
  termsAndCond: { bn: "শর্তাবলী", en: "Terms & Condition" },
  // Bottom nav
  home: { bn: "হোম", en: "Home" },
  cart: { bn: "কার্ট", en: "Cart" },
  offer: { bn: "অফার", en: "Offer" },
  settings: { bn: "সেটিংস", en: "Settings" },

  // Drawer menu tabs
  category: { bn: "ক্যাটাগরি", en: "Category" },
  menu: { bn: "ম্যানু", en: "Menu" },
  hotOffers: { bn: "হট অফার", en: "Hot Offers" },
  orderDetails: { bn: "অর্ডার", en: "Orders" },
  viewCart: { bn: "কার্ট দেখুন", en: "View Cart" },
  subTotal: { bn: "সর্বমোট", en: "Sub Total" },
  order: { bn: "অর্ডার করুন", en: "Buy Now" },

  // Section headings
  featuredCategories: { bn: "ক্যাটাগরি", en: "Categories" },
  newProducts: { bn: "নতুন পণ্য", en: "New Products" },
  freshArrival: { bn: "নতুন আগমন", en: "Fresh Arrivals" },
  trendingProducts: { bn: "জনপ্রিয় পণ্য", en: "Popular Products" },
  freeDelivery: { bn: "ফ্রি ডেলিভারি অফার", en: "Free Delivery Offer" },
  freeShipping: { bn: "ফ্রি ডেলিভারি অফার", en: "Free Shipping Offer" },
  viewAll: { bn: "সব দেখুন", en: "See All" },

  //Hot Offer
  shortTimeOffer: {
    bn: "সীমিত সময়ের ফ্ল্যাশ সেল!",
    en: "Limited Time Flash Sale!",
  },
  grabTheOffer: {
    bn: "অফার শেষ হওয়ার আগে এখনই অর্ডার করুন",
    en: "Order now before the offer ends",
  },

  //why us
  fastestDelivery: { bn: "দ্রুত ডেলিভারি", en: "Fastest Delivery" },
  cashOnDelivery: { bn: "ক্যাশ অন ডেলিভারি", en: "Cash on Delivery" },
  support: { bn: "২৪/৭ সেবা", en: "24/7 Support" },
  whyChooseUs: { bn: "কেন আমাদের পছন্দ করবেন", en: "Why Choose Us" },

  // Category wise data
  subCategories: { bn: "সাব ক্যাটাগরি", en: "Sub Categories" },
  priceRange: { bn: "দামের রেঞ্জ", en: "Price Range" },
  selectedRange: { bn: "নির্বাচিত রেঞ্জ", en: "Selected Range" },
  itemsFound: { bn: "টি পণ্য পাওয়া গেছে", en: "Items Found" },
  filter: { bn: "ফিল্টার", en: "Filter" },
  latest: { bn: "সর্বশেষ", en: "Latest" },
  priceLowToHigh: { bn: "দাম: কম থেকে বেশি", en: "Price: Low to High" },
  priceHighToLow: { bn: "দাম: বেশি থেকে কম", en: "Price: High to Low" },
  popularCategories: { bn: "জনপ্রিয় ক্যাটাগরি", en: "Popular Categories" },

  // Product card / actions
  orderNow: { bn: "অর্ডার করুন", en: "Order Now" },
  addToCart: { bn: "এড টু কার্ট", en: "Add to Cart" },
  stockOut: { bn: "স্টক শেষ", en: "Out of Stock" },
  addedToCart: {
    bn: "পণ্যটি কার্টে যোগ করা হয়েছে 🛒",
    en: "Added to the cart 🛒",
  },
  freeDeliveryBadge: { bn: "ফ্রি ডেলিভারী", en: "Free Delivery" },

  //Confirm Order
  ClickForMoreOrder: {
    bn: "আরো অর্ডার করতে বা পণ্য দেখতে এখানে ক্লিক করুন",
    en: "Click here to browse more products",
  },
  ConfirmOrder: { bn: "অর্ডার কনফার্ম হয়েছে", en: "Order has been confirmed" },
  orderReceived: {
    bn: "আপনার অর্ডারটি সফলভাবে গ্রহণ করা হয়েছে।",
    en: "Your order has been confirmed.",
  },
  ourAgentContact: {
    bn: "খুব শীঘ্রই আমাদের প্রতিনিধি আপনার সাথে যোগাযোগ করবে",
    en: "Our representative will contact you shortly.",
  },
  thanksForOrder: {
    bn: "Nabil Fashion থেকে কেনাকাটার জন্য ধন্যবাদ",
    en: "Thanks for purchasing from Nabil Fashion",
  },

  // Product details
  selectVariant: { bn: "ভেরিয়েন্ট বেছে নিন", en: "Select Variant" },
  chooseYourPreferredVariant: {
    bn: "আপনার পছন্দের ভ্যারিয়েন্ট নির্বাচন করুন",
    en: "Choose your preferred variant",
  },
  size: { bn: "সাইজ", en: "Size" },
  color: { bn: "রঙ", en: "Color" },
  description: { bn: "বিবরণ", en: "Description" },
  relatedProducts: { bn: "সংশ্লিষ্ট প্রোডাক্ট", en: "Related Products" },
  orderByPhone: { bn: "অর্ডার করুন ফোনে", en: "Order by Phone" },
  orderOnWhatsapp: { bn: "WhatsApp", en: "WhatsApp" },
  stayConnected: { bn: "আমাদের সাথে যুক্ত থাকুনঃ", en: "Stay connected:" },
  productDetails: { bn: "পণ্যের বিস্তারিত", en: "Product Details" },
  quantity: { bn: "পরিমাণ", en: "Quantity" },
  youMayLike: { bn: "আপনার পছন্দ", en: "You May Like" },
  problemWithOrder: {
    bn: "প্রোডাক্ট অর্ডার করতে সমস্যা হচ্ছে?",
    en: "Having trouble placing an order?",
  },
  contactWithUs: {
    bn: "আমাদের সাথে সরাসরি যোগাযোগ করুন",
    en: "Contact us directly",
  },

  //Trending, New, Free-Delivery Full Page
  trending: {
    bn: "ট্রেন্ডিং",
    en: "Trending",
  },
  trendingTitle: {
    bn: "গ্রাহকদের সবচেয়ে পছন্দের এবং বেশি বিক্রি হওয়া পণ্যগুলো এক জায়গায় খুঁজে নিন। আপনার ডাইনিং ও কিচেনকে আরও আকর্ষণীয় করতে সেরা সংগ্রহ বেছে নিন।",
    en: "Discover our best-selling item loved by customers. Explore the most popular collections to elevate your dining and kitchen experience.",
  },
  trendingNow: {
    bn: "ট্রেন্ডিং পণ্য",
    en: "Trending Now",
  },
  mostPopular: {
    bn: "সবচেয়ে জনপ্রিয়",
    en: "Most Popular",
  },
  newProductTitle: {
    bn: "নতুন নতুন সব পণ্য বিভিন্ন ক্যাটাগরিতে — নিয়মিত আপডেট করা হয় যাতে আপনি মিস না করেন",
    en: "Fresh arrivals across categories — updated regularly so you never miss a new drop",
  },
  newArrivals: {
    bn: "নতুন আগমন",
    en: "New Arrivals",
  },
  justLanded: {
    bn: "এখনই এসেছে",
    en: "Just Landed",
  },
  zeroShipping: {
    bn: "ফ্রি ডেলিভারি খরচ",
    en: "Zero Shipping Cost",
  },
  freeDeliveryProduct: {
    bn: "ফ্রি ডেলিভারি পণ্য",
    en: "Free Delivery Product",
  },
  freeShippingTitle: {
    bn: "এই পেজের প্রতিটি পণ্যে রয়েছে ফ্রি ডেলিভারি — চেকআউটে কোনো অতিরিক্ত শিপিং চার্জ নেই।",
    en: "Every item on this page comes with free delivery — no extra shipping fees at checkout.",
  },
  alwaysFreeDelivery: {
    bn: "ফ্রি ডেলিভারি",
    en: "Free delivery",
  },
  discountIncluded: {
    bn: "ডিসকাউন্ট অন্তর্ভুক্ত",
    en: "Discount included",
  },

  // Order / cart page
  deliveryAddress: { bn: "ডেলিভারি ঠিকানা", en: "Delivery Address" },
  name: { bn: "নাম", en: "Name" },
  phone: { bn: "নাম্বার", en: "Phone" },
  phoneNumber: {
    bn: `নাম্বার: ${toBanglaDigits(CONTACT_INFO.phone.display)} `,
    en: `Phone: ${CONTACT_INFO.phone.display}`,
  },
  callNow: { bn: "কল করুন", en: "Call Now" },
  address: { bn: "ঠিকানা", en: "Address" },
  district: { bn: "জেলা", en: "District" },
  delivery: { bn: "ডেলিভারি", en: "Delivery" },
  deliveryFee: { bn: "ডেলিভারি ফি", en: "Delivery Fee" },
  toBeAdded: { bn: "যোগ করা হবে", en: "To be added" },
  totalCost: { bn: "মোট খরচ", en: "Total Cost" },
  yourOrder: { bn: "আপনার অর্ডার", en: "Your Order" },
  subtotal: { bn: "মোট", en: "Subtotal" },
  deliveryCharge: { bn: "ডেলিভারী খরচ", en: "Delivery Charge" },
  grandTotal: { bn: "সর্বমোট", en: "Grand Total" },
  placeOrder: { bn: "অর্ডার করুন", en: "Place Order" },
  TK: { bn: "টাকা", en: "TK" },
  myCart: { bn: "কার্ট", en: "My Cart" },
  emptyCart: { bn: "কোনো পণ্য পাওয়া যায়নি", en: "Your cart is empty" },
  nextStep: { bn: "পরবর্তী ধাপ", en: "Proceed to Checkout" },
  DeliveryOneDay: { bn: "ডেলিভারি সময় ১দিন", en: "Delivery within 1 day" },
  DeliveryManyDay: {
    bn: "ডেলিভারি সময় ২দিন",
    en: "Delivery within 2-3 day",
  },
  submitOrder: { bn: "অর্ডার করুন", en: "Submit Order" },
  price: { bn: "দাম", en: "Price" },
  items: { bn: "টি", en: "items" },
  orderList: { bn: "অর্ডার তালিকা", en: "Order List" },
  moneyAfterReceiveProduct: {
    bn: "( পণ্য হাতে পেয়ে মূল্য পরিশোধ )",
    en: "( Pay After Receiving the Product )",
  },
  orderDetail: { bn: "অর্ডার বিবরণ", en: "Order Details" },
  deliveryOptions: { bn: "ডেলিভারি অপশন", en: "Delivery Options" },
  Checkout: { bn: "চেকআউট", en: "Checkout" },
  whatsappOrderForOther: {
    bn: " অন্যের জন্য অর্ডার করলে Whatsapp নাম্বার",
    en: "WhatsApp Number (If Ordering for Someone Else)",
  },

  // Flash sale / hot offer
  incredibleDiscount: {
    bn: "অবিশ্বাস্য মূল্য ছাড়!!",
    en: "Incredible Discounts!!",
  },
  flashSale: { bn: "ফ্ল্যাশ সেল", en: "Flash Sale" },
  days: { bn: "দিন", en: "Days" },
  hours: { bn: "ঘন্টা", en: "Hours" },
  minutes: { bn: "মিনিট", en: "Minutes" },
  seconds: { bn: "সেকেন্ড", en: "Seconds" },
  noOfferYet: {
    bn: "শীঘ্রই নতুন পণ্যে অফার দেওয়া হবে",
    en: "New offers coming soon",
  },
  comingSoon: {
    bn: "শীঘ্রই নতুন পণ্য যুক্ত করা হবে।",
    en: "New products coming soon.",
  },

  // Misc
  somethingWrong: { bn: "কিছু একটা সমস্যা হয়েছে", en: "Something went wrong" },
  noCategory: { bn: "কোনো ক্যাটাগরি নেই", en: "No categories found" },
  watchOurProducts: { bn: "আমাদের পণ্য দেখুন", en: "Watch & Explore" },
  topCategories: { bn: "টপ ক্যাটাগরি", en: "Top Categories" },
  confirmOrderMsg: {
    bn: "আপনার অর্ডারটি কনফার্ম করা হয়েছে, খুব শীঘ্রই আমাদের প্রতিনিধি আপনার সাথে যোগাযোগ করবে",
    en: "Your order has been confirmed. Our representative will contact you shortly.",
  },
  freeDeliveryPromo: {
    bn: "টাকার পণ্য কিনলেই পাচ্ছেন সারা বাংলাদেশ ফ্রি ডেলিভারী অফার",
    en: "worth of products gets you free delivery across Bangladesh",
  },
  freeDeliveryOffer: {
    bn: "FREE DELIVERY OFFER PRODUCTS",
    en: "FREE DELIVERY OFFER PRODUCTS",
  },
  insideDhaka: { bn: "ঢাকার ভিতর", en: "Inside Dhaka" },
  outsideDhaka: { bn: "ঢাকার বাহিরে", en: "Outside Dhaka" },
  dhakaSubarea: { bn: "ঢাকা সাবএরিয়া", en: "Dhaka Subarea" },
  pickupFromStore: { bn: "দোকান থেকে সংগ্রহ", en: "Pickup from Store" },
  deliveryWithin24Hours: {
    bn: "২৪ ঘণ্টার মধ্যে ডেলিভারি",
    en: "Delivery within 24 hours",
  },
  deliveryWithin2Hours: {
    bn: "২-৩ দিনের মধ্যে ডেলিভারি",
    en: "Delivery within 2-3 days",
  },
  fast: { bn: "দ্রুত", en: "Fast" },
  standard: { bn: "স্ট্যান্ডার্ড", en: "Standard" },
  connectWithUs: { bn: "আমাদের সাথে যুক্ত থাকুন", en: "Connect With Us" },
  followUsOnSocialMedia: {
    bn: "সোশ্যাল মিডিয়ায় আমাদের অনুসরণ করুন",
    en: "Follow us on social media",
  },
  // FAQ
  faqBadge: { bn: "পড়ুন আগে?", en: "Read First" },
  faqTitle: { bn: "সচরাচর জিজ্ঞাসা", en: "Frequently Asked Questions" },
  faqQuestion1: { bn: "ডেলিভারি কতদিনে পাবো?", en: "How long does delivery take?" },
  faqAnswer1: {
    bn: "ঢাকার ভেতরে সাধারণত ২৪–৪৮ ঘণ্টা এবং সারাদেশে ৩–৫ কার্যদিবসের মধ্যে ডেলিভারি দেওয়া হয়।",
    en: "Inside Dhaka, delivery usually takes 24-48 hours, and outside Dhaka it takes 3-5 business days.",
  },
  faqQuestion2: { bn: "পেমেন্ট কীভাবে করব?", en: "How can I pay?" },
  faqAnswer2: {
    bn: "আপনি ক্যাশ অন ডেলিভারি, মোবাইল ব্যাংকিং, অথবা আমাদের কাস্টমার সাপোর্টের মাধ্যমে পেমেন্ট করতে পারবেন।",
    en: "You can pay via cash on delivery, mobile banking, or through our customer support team.",
  },
  faqQuestion3: { bn: "সব পণ্য কি স্টকে থাকে?", en: "Are all products always in stock?" },
  faqAnswer3: {
    bn: "আমরা নিয়মিত স্টক আপডেট করি, তবে কিছু পণ্য সীমিত সময়ের জন্য অ্যাভেইলেবল থাকতে পারে।",
    en: "We update stock regularly, but some products may be available for a limited time.",
  },
  faqQuestion4: { bn: "রিটার্ন করতে চাইলে কী করব?", en: "What if I need to return something?" },
  faqAnswer4: {
    bn: "প্রোডাক্ট রিসিভ করার পর কোনো সমস্যা থাকলে দ্রুত আমাদের সাথে যোগাযোগ করুন, আমরা রিটার্ন/এক্সচেঞ্জে সহায়তা করব।",
    en: "If you have any issue after receiving the product, contact us quickly and we’ll help with return or exchange support.",
  },
  faqQuestion5: { bn: "ফটো আর বাস্তব পণ্যের মধ্যে পার্থক্য থাকে?", en: "Is there a difference between the photo and the real product?" },
  faqAnswer5: {
    bn: "আমরা যতটা সম্ভব বাস্তব পণ্যের কাছাকাছি ছবি দেখাই, তবে স্ক্রিনের আলো ও রঙের কারণে সামান্য পার্থক্য হতে পারে।",
    en: "We try to show product photos as accurately as possible, but slight differences may appear because of screen and lighting variation.",
  },
};

/**
 * @param {string} key
 * @param {"bn"|"en"} lang
 * @returns {string}
 */
export const t = (key, lang = "bn") => {
  const entry = translations[key];
  if (!entry) return key;
  return entry[lang] ?? entry["bn"] ?? key;
};

export default translations;
